// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qPsi","col":"styles_col__cTn6k"};